export class Bookset {
  constructor(bookset) {
    Object.assign(this, bookset);
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: {
        bookset: this,
      },
    };
  }
}

export class Genre {
  constructor(genre) {
    Object.assign(this, genre);
  }

  getGenreUrl() {
    return this.absolute_url
      ? this.absolute_url
      : `/catalog/${this.niche.slug}/${this.slug}/`;
  }

  getLink() {
    return {
      pathname: this.getGenreUrl(),
      state: { genre: this },
    };
  }
}

export class Niche {
  constructor(niche) {
    const slug = niche.slug ? niche.slug : niche.absolute_url;
    Object.assign(this, niche, { slug });
  }

  getUrl() {
    return this.absolute_url
      ? this.absolute_url
      : `/catalog/${this.slug}/`;
  }

  getBookListUrl() {
    return this.absolute_url
      ? `${this.absolute_url}/books`
      : `/catalog/${this.slug}/books/`;
  }

  getFreeBookListUrl() {
    return this.absolute_url
      ? `${this.absolute_url}/books/free/`
      : `/catalog/${this.slug}/books/free/`;
  }

  getAudioBookListUrl() {
    return `/catalog/${this.slug}/books/audio/`;
  }

  getAudioBookListUrl() {
    return `/catalog/${this.slug}/books/audio/`;
  }

  getLink() {
    return {
      pathname: this.getUrl(),
      state: { niche: this },
    };
  }

  getBookListLink() {
    return {
      pathname: this.getBookListUrl(),
      state: { niche: this },
    };
  }

  getFreeBookListLink() {
    return {
      pathname: this.getFreeBookListUrl(),
      state: { niche: this },
    };
  }

  getAudioBookListLink() {
    return {
      pathname: this.getAudioBookListUrl(),
      state: { niche: this },
    };
  }
}

export class Series {
  constructor(series) {
    Object.assign(this, series);
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: { series: this },
    };
  }
}

export class Author {
  constructor(author) {
    Object.assign(this, author);
  }

  getBookListUrl() {
    return `${this.absolute_url}books/`;
  }

  getAudioBookListUrl() {
    return `${this.absolute_url}books/audio/`;
  }

  getReviewListUrl() {
    return `${this.absolute_url}reviews/`;
  }

  getCitationListUrl() {
    return `${this.absolute_url}citations/`;
  }

  getBookListLink() {
    return {
      pathname: this.getBookListUrl(),
      state: { author: this },
    };
  }

  getAudioBookListLink() {
    return {
      pathname: this.getAudioBookListUrl(),
      state: { author: this },
    };
  }

  getReviewListLink() {
    return {
      pathname: this.getReviewListUrl(),
      state: { author: this },
    };
  }

  getCitationListLink() {
    return {
      pathname: this.getCitationListUrl(),
      state: { author: this },
    };
  }

  getLink() {
    return {
      pathname: this.absolute_url,
      state: { author: this },
    };
  }
}

export class Actor {
  constructor(actor) {
    Object.assign(this, actor);
  }

  getUrl() {
    return this.absolute_url
      ? this.absolute_url
      : `/actor/${this.slug}/`;
  }

  getLink() {
    return {
      pathname: this.getUrl(),
      state: {
        actor: this,
      },
    };
  }
}

export class Tag {
  constructor(tag) {
    Object.assign(this, tag);
  }

  getUrl() {
    return this.absolute_url
      ? this.absolute_url
      : `/tags/${this.slug}/`;
  }

  getLink() {
    return {
      pathname: this.getUrl(),
      state: {
        tag: this,
      },
    };
  }
}

export class Rightholder {
  constructor(rightholder) {
    this.rightholder = { ...rightholder };
  }

  getUrl() {
    return `/rightholder/${this.rightholder.slug}/`;
  }

  getLink() {
    return {
      pathname: this.getUrl(),
      state: {
        rightholder: this.rightholder,
      },
    };
  }
}
